import { render, staticRenderFns } from "./Taxday.vue?vue&type=template&id=664d55f6&scoped=true&"
import script from "./Taxday.vue?vue&type=script&lang=js&"
export * from "./Taxday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d55f6",
  null
  
)

export default component.exports